<template>
	<div 
		@mousedown="startDrag"
		ref="floatButton"
		class="float-info"
		:style="{'left': left + 'px', 'top': !isShow ? top + 'px' : verticalSpace + 'px'}"
		>
		<div v-show="!isShow" class="hoveBtn">
			<img style="width: 100px; height: 100px; cursor: pointer;" @click="clickShow" draggable="false" src="../../assets/icon_home_ai_logo_1.gif" alt="" />
			<div class="tip" :style="{ left: clientWidth  / 2 > left ? '100px' : 'unset', right: clientWidth  / 2 <= left ? '100px' : 'unset' }">
				<img v-if="clientWidth  / 2 > left" style="width: 12px; height: 38px;" draggable="false" src="../../assets/icon_home_ai_arrow_31.png" alt="" />
				<div style="background: #497AE5; border-radius: 8px; font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #FFFFFF; line-height: 24px; padding: 16px; white-space: nowrap;">点击唤醒AI：省人力、秒解疑、筑医知</div>
				<img v-if="clientWidth  / 2 <= left" style="width: 12px; height: 38px;" draggable="false" src="../../assets/icon_home_ai_arrow_30.png" alt="" />
			</div>
		</div>
		<div v-show="isShow" style="height: calc(100vh - 40px); display: flex; flex-direction: column;" :style="{opacity: isShow ? 1 : 0}">
			<div style="width: 500px; background: rgba(236,240,243,0.8); box-shadow: 0px 0px 34px 0px rgba(192,197,202,0.5); border-radius: 16px; border: 1.5px solid rgba(149, 39, 255, 0.5); backdrop-filter: blur(6px); position: relative; display: flex; flex-direction: column; overflow: hidden; height: 100vh;" :style="{ width: isShow ? '500px' : '0px' }">
				<img style="position: absolute; width: 500px; height: 370px; left: 0px; top: 0px; z-index: -1;" src="../../assets/icon_home_ai_icon_0.png" alt="" draggable="false" />
				<div style="display: flex; justify-content: space-between; padding-left: 20px; padding-right: 20px; margin-top: 20px; margin-bottom: 15px;">
					<img style="width: 78px; height: 20px;" src="../../assets/icon_home_ai_icon_1.png" alt="" draggable="false" />
					<img @click="clickCloseAi" style="width: 24px; height: 24px; cursor: pointer;" src="../../assets/icon_home_ai_icon_2.png" alt="" draggable="false" />
				</div>


				<div class="markdownContent-hoverBtn" @mouseenter="mouseenter" @mouseleave="mouseleave" id="contentScrollId-hoverBtn" :class="['tca', 'hiddenScrollbar']" style="display: block; flex-direction: column; align-self: flex-start; padding-left: 20px; padding-right: 20px; overflow: scroll; width: 100%; padding-bottom: 2px; flex: 1;" draggable="false">
					
					<div v-for="(item, index) in msgArr" style="display: flex; flex-direction: column;">
						<div v-if="item.type == 'start'" style="border-radius: 2px 12px 12px 12px; background: #FFFFFF; display: flex; flex-direction: column; padding-left: 20px; padding-right: 20px; padding-bottom: 20px; width: 392px;">
							<img style="width: 60px; height: 60px; margin-top: 10px; margin-left: -5px;" draggable="false" src="../../assets/icon_home_ai_logo_2.gif" alt="" />
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px;">Hi～，我是清雷AI助手，很乐意为你提高工作效率</div>
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #5E6779; line-height: 20px; margin-top: 5px;">试试以下指令吧：</div>
							<div style="background: rgba(74, 124, 232, 0.2); border-radius: 20px 20px 20px 2px; backdrop-filter: blur(8px); display: flex; align-items: center; padding: 10px; align-self: flex-start; margin-top: 10px; cursor: pointer;" @click="clickAiAnalysis(null)">
								<div style="width: 10px; height: 10px; border: 2px solid rgba(74, 124, 232, 0.5); border-radius: 5px; margin-right: 5px;"></div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #5E6779; line-height: 20px;">帮我解读“当日需及时关心的长者”</div>
							</div>
						</div>
						<div v-else-if="item.type == 'start-1'" style="border-radius: 2px 12px 12px 12px; background: #FFFFFF; display: flex; flex-direction: column; padding-left: 20px; padding-right: 20px; padding-bottom: 20px; width: 392px;">
							<img style="width: 60px; height: 60px; margin-top: 10px; margin-left: -5px;" draggable="false" src="../../assets/icon_home_ai_logo_2.gif" alt="" />
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px;">Hi～，我是清雷AI助手，很乐意为你提高工作效率</div>
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 16px; color: rgba(158, 164, 175, 1); line-height: 22px; margin-top: 5px;">我能帮你解读睡眠报告、分析呼吸心跳数据，还能根据你的睡眠质量给出改善小贴士！比如教你调整作息、推荐夜间健康体检服务，或者提醒你关注呼吸机使用的重要性~</div>
							
							<div v-if="questions && questions.length > 0" style="display: flex; flex-direction: column; margin-top: 15px;">
								<div style="height: 1px; background: rgba(94, 103, 121, 0.1);"></div>
								<div style="display: flex; align-items: center; margin-top: 15px;">
									<img style="width: 16px; height: 16px; margin-right: 5px;" src="../../assets/icon_home_ai_icon_16.png" alt="" draggable="false" />
									<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #4A7CE8; line-height: 20px;">你是否想了解：</div>
								</div>
								<div style="display: flex; flex-direction: column;">
									<div v-for="(item, index) in questions || []" style="background: rgba(74, 124, 232, 0.2); border-radius: 20px 20px 20px 2px; backdrop-filter: blur(8px); display: flex; align-items: center; padding: 10px; align-self: flex-start; margin-top: 10px; cursor: pointer;" @click="clickAiQuestion(item)">
										<div style="width: 10px; height: 10px; border: 2px solid rgba(74, 124, 232, 0.5); border-radius: 5px; margin-right: 5px;"></div>
										<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #5E6779; line-height: 20px;">{{item}}</div>
									</div>
								</div>
							</div>
						</div>
						<div v-else-if="item.type == 'analysis'" style="display: flex; justify-content: flex-end;">
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px; padding: 20px; background: rgba(74, 124, 232, 0.2); border-radius: 12px 2px 12px 12px; margin-top: 15px; align-self: flex-end; min-width: 391px;">{{ item.text }}</div>
						</div>
						<div v-else-if="item.type == 'aiContent'" style="display: flex;">
							<AiHoverBtnCard1 v-if="(msgArr[0].type == 'start' && index <= 2)" ref="aiHoverBtnCard1RefReport" :data="item" :dataIndex="index" :msgArr="msgArr" :modelValue.sync="sessionId" :shareTitle="shareTitle" :shareSubTitle="shareSubTitle" @changeMsgArr="changeMsgArr" @clickAiAnalysis="clickAiAnalysis" @changeShareTitle="changeShareTitle" @changeShareSubTitle="changeShareSubTitle" @requestFinish="requestFinish" @typewritingFinish="typewritingFinish" />
							<AiHoverBtnCard2 v-if="msgArr[0].type == 'start-1' || index > 2" ref="aiHoverBtnCard2RefReport" :isRandom="msgArr[0].type == 'start-1' && index == 2" :data="item" :dataIndex="index" :msgArr="msgArr" :modelValue.sync="sessionId" :shareTitle="shareTitle" :shareSubTitle="shareSubTitle" @changeMsgArr="changeMsgArr" @clickAiAnalysis="clickAiAnalysis" @changeShareTitle="changeShareTitle" @changeShareSubTitle="changeShareSubTitle" @requestFinish="requestFinish" @typewritingFinish="typewritingFinish"/>
						</div>
					</div>

					<div v-if="isLoading" style="display: flex; height: 120px; background: #FFFFFF; box-shadow: 0px 0px 10px 0px #D9E7F1; border-radius: 2px 12px 12px 12px; margin-top: 15px; overflow: hidden;" v-loading="isLoading" element-loading-text="AI分析中，请稍候..." class="loadingContent"></div>
				</div>

				<div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;">
					<div :class="['my-el-input-ai-report-container', isEditing || (searchText && searchText.length > 0) || aiIsRequest ? 'my-el-input-ai-report-container-editing' : '']">
						<!-- <el-input
							:class="'my-el-input-ai-report', isEditing  || (searchText && searchText.length > 0) || aiIsRequest ? 'my-el-input-ai-report-editing' : ''"
							v-model="searchText"
							:autosize="{ minRows: 0, maxRows: 12 }"
							type="textarea"
							placeholder="输入你的问题，帮你深度解答"
							:show-word-limit="false"
							:resize="'none'"
							@focus="handleFocus" @blur="handleBlur" @keyup.enter="removeFocus" readonly onfocus="this.removeAttribute('readonly');"
						/> -->

						<textarea
							class="deepseek-textarea"
							v-model="searchText"
							@input="adjustHeight"
							@keydown.enter.exact.prevent="sendMessage"
							@keydown.shift.enter.prevent="newLine"
							@focus="handleFocus"
							@blur="handleBlur"
							placeholder="输入你的问题，帮你深度解答"
							ref="deepseekTextareaRef"
						>
						</textarea>
						
						<div :class="['search-btn', searchText && searchText.length > 0 ? 'search-btn-can-search' : '', aiIsRequest ? 'search-btn-searching' : '']" @click="clickAiSearch"></div>
					</div>
				</div>

				<div style="display: flex; justify-content: center; align-items: center; margin-bottom: 10px; margin-top: 10px;">
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(94, 103, 121, 0.6); line-height: 20px;">内容由 AI 大模型生成，请仔细甄别</div>
					<div></div>
				</div>
			</div>
		</div>
		<div v-if="toastStr" style="position: absolute; background: rgba(0, 0, 0, 0.5); border-radius: 8px; backdrop-filter: blur(8px); padding: 15px; display: flex; justify-content: center; align-items: center;">
			<img style="width: 16px; height: 16px; margin-right: 5px;" src="../../assets/icon_home_ai_icon_10.png" alt="" draggable="false" />
			<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #FFFFFF; line-height: 22px;">{{ toastStr }}</div>
		</div>
	</div>
</template>
  
<script>

import {marked} from 'marked'
import QRCode from "qrcodejs2";
import axios from 'axios';
import AiHoverBtnCard1 from "./aiHoverBtnCard1.vue"
import AiHoverBtnCard2 from "./aiHoverBtnCard2.vue"

const sleep = async (time) => {
    return new Promise((res) => {
        setTimeout(() => {
            res(true);
        }, time);
    });
};
const markdown = '';
const parseToken = (token) => {
    const whitelist = ['link', 'image', 'video'];
    if (token.type.indexOf(whitelist) < 0 && (token.tokens && token.tokens.length > 0 || token.items && token.items.length > 0)) {
        let pre, hz = "";
        if (token.text) {
            let zz = token.raw.split(token.text);
            if (zz && zz.length > 1) {
                pre = zz && zz[0] ? zz[0] : "";
                hz = zz && zz[1] ? zz[1] : "";
            }
        }
        let tks = [];
		if (token.items && token.items.length > 0) {
			for (let index = 0; index < token.items.length; index++) {
				const tk = token.items[index];
				const itemtks = parseToken(tk);
				if (pre || hz) {
					tks.push({
						pre,
						hz,
						itemtks
					});
				} else {
					tks = tks.concat(itemtks);
				}
			}
		} else {
			for (let index = 0; index < token.tokens.length; index++) {
				const tk = token.tokens[index];
				const itemtks = parseToken(tk);
				if (pre || hz) {
					tks.push({
						pre,
						hz,
						itemtks
					});
				} else {
					tks = tks.concat(itemtks);
				}
			}
		}
        return tks;
    }
    if (token.type == 'text') {
        return token.text.split("");
    }
    return [token.raw];
};

const renderItemTk = async (showMdText, tktxt, obj) => {
    if (typeof tktxt == 'string') {
        showMdText += tktxt;
        obj.mdhtml = marked.parse(showMdText);
        await sleep(120);
    } else {
        for (let m = 0; m < tktxt.itemtks.length; m++) {
            const item = tktxt.itemtks[m];
            if(typeof item != 'string'){
                tktxt.itemtks[m] = "";
                showMdText = await renderItemTk(showMdText, item, obj);
            }
            let nmd = showMdText + tktxt.pre + tktxt.itemtks.slice(0, m + 1).join("") + tktxt.hz;
            obj.mdhtml = marked.parse(nmd);
            if (m === tktxt.itemtks.length - 1) {
                showMdText = nmd;
            }
            await sleep(120);
        }
    }
    return showMdText;
};

export default {
	components: { AiHoverBtnCard1, AiHoverBtnCard2 },
	props: {
		firstCardData: null
	},
	computed: {
	},
	watch: {
		scrollTop(newValue, oldValue) {
			setTimeout(() => {
			if(newValue == window.scrollY) { //延时执行后当newValue等于window.scrollY，代表滚动结束
				//console.log('滚动结束');
				if (this.left == 15){  //按钮在页面左侧
					this.left = this.left + 40
				}else if (this.left < 15){
					this.left = 15
				}else {
					this.left = this.left - 40
				}
				this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
			};
			}, 20); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
		}
	},
	data() {
		return {
			
			timer: null,
			currentTop: 0,
			left: 0,
			top: 0,

			oldScrollTop: 0,  //记录上一次滚动结束后的滚动距离
			scrollTop: 0,     // 记录当前的滚动距离


			dragging: false,
			mouseX: 0,				// 鼠标 X
			mouseY: 0,				// 鼠标 Y
			initialX: 0,
			initialY: 0,
			offsetX: 0,
			offsetY: 0,

			
			

			isShow: false,


			rawContent: '',
			displayedContent: '',
			interval: null,
			index: 1,

			mdhtml: '',

			isUnfold: true,

			isScrollBottom: true,

			isLoading: false,


			clientWidth: 0, // 页面宽度
			clientHeight: 0, // 页面高度
			itemWidth: 100, // 整个内容宽度
			itemHeight: 100, // 整个内容高度
			horizontalSpace: 20, // 水平顶部和底部最小间距
			verticalSpace: 0, // 垂直顶部和底部最小间距
			toastStr: null,
			isShowQrCode: false,
			qrCodeIsLoading: false,
			/**
			 type: 
			 	start				顶部起始卡片
				analysis			分析 - 用户点击分析、帮我解读
				aiContent			AI分析的内容
			*/
			msgArr: null,

			shareTitle: '清雷AI助手',
			shareSubTitle: '点击查看AI解读',
			aiIsRequest: false,
			source: null,
			eventId: null,

			searchText: null,
			isEditing: false,

			sessionId: null,

			questions: null
		};
	},
	created() {

		if (this.$props.firstCardData) {
			this.msgArr = [
				{
					"type": 'start'
				}
			];
		} else {
			let tempAuestions = [
				'什么是“吸呼比”？',
				'“吸呼比”异常可能预示哪些呼吸系统疾病？',
				'“吸呼比”与COPD（慢阻肺）的关联性？',
				'“呼吸异常指数”超过多少需要紧急干预？',
				'“深睡时长”的临床意义？',
				'“深睡时长”不足如何影响老人健康？',
				'“体动次数”增多和哪些因素有关？',
				'如何定义“体动指数”？',
				'“体动指数”与不宁腿综合症的关联性？',
				'“呼吸率”突然升高可能由哪些疾病引起？',
				'冬季“平均呼吸率”是否普遍低于夏季？',
				'“睡眠效率”低于80%对认知功能有何影响？',
				'“睡眠间离床”与“夜醒时长”的区别？',
				'毫米波有辐射吗？',
				'被子太厚会影响呼吸监测吗？',
				'如何利用睡眠数据优化餐饮时间表？',
				'如何利用数据指标开展健康活动？',
				'如何利用健康指标改善老人睡眠质量？',
				'如何利用“离床时间+体动次数”预测跌倒风险？',
				'能否用“睡眠效率”来评估环境改造效果？'
			];
			this.questions = this.getRandomThreeUnique(tempAuestions);
			this.msgArr = [
				{
					"type": 'start-1'
				}
			];
		}

		this.clientWidth = document.documentElement.clientWidth;
		this.clientHeight = document.documentElement.clientHeight;
		// this.clientWidth = document.body.clientWidth;
		// this.left = this.clientWidth - this.itemWidth - this.gapWidth
		// this.top = this.clientHeight * this.coefficientHeight

		this.left = this.clientWidth - 100 - 30;
		this.top = this.clientHeight - 100 - 30 - 500


		console.log('===监听窗口变化')
		window.addEventListener('resize', () => {
			console.log('===监听窗口变化')
			this.clientWidth = document.body.clientWidth;
			this.clientHeight = document.documentElement.clientHeight;
			this.optimizedLocation();
		});
	},
	mounted() {
		// // 创建 EventSource 对象
		// const eventSource = new EventSource('http://192.168.1.16:9527/api/sse/createConnect');
		// this.source = eventSource;
		// // 监听 - 服务器发送的事件
		// let that = this;
		// eventSource.onmessage = function(event) {
		// 	console.log('===id===', JSON.parse(event.data).clientId)
		// 	that.eventId = JSON.parse(event.data).clientId;
		// 	console.log('SSE - 收到消息 - ', event.data);
		// };
		// // 监听 - 服务器关闭连接的事件
		// eventSource.onclose = function(e) {
		// 	console.log('SSE - 连接已关闭', e);
		// };
		// // 监听 - 服务器错误事件
		// eventSource.onerror = function(e) {
		// 	console.log('SSE - 连接出错', e);
		// };
		// // 监听 - 连接成功
		// eventSource.addEventListener('open', () => {
		// 	console.log('SSE - Open - 连接成功')
		// })
		// // 监听 - 收到自定义消息
		// eventSource.addEventListener('message', e => {
		// 	console.log('SSE - Message - 收到自定义消息', e)
		// })
		// // 监听 - 出错了
		// eventSource.addEventListener('error', e => {
		// 	console.log('SSE - Error - 出错了', e)
		// })
		
		this.$nextTick(() => {
			// const floatButton = this.$refs.floatButton
			// floatButton.addEventListener("touchstart", () => {
			// 	floatButton.style.transition = 'none'
			// })

			// // 在拖拽的过程中，组件应该跟随手指的移动而移动。
			// floatButton.addEventListener("touchmove", (e) => {
			// 	if (e.targetTouches.length === 1) {         // 一根手指
			// 		document.body.addEventListener('touchmove', this.bodyScroll, { passive: false });  //禁止页面滑动
			// 		let touch = e.targetTouches[0]
			// 		this.left = touch.clientX - 20
			// 		this.top = touch.clientY - 25
			// 	}
			// })

			// // 拖拽结束以后，重新调整组件的位置并重新设置过度动画。
			// floatButton.addEventListener("touchend", () => {
			// 	document.body.removeEventListener('touchmove', this.bodyScroll, { passive: false });  //解除页面禁止滑动
			// 	floatButton.style.transition = 'all 0.3s'
			// 	if(this.left > document.documentElement.clientWidth / 2) {
			// 		this.left = document.documentElement.clientWidth - 70;
			// 	}else{
			// 		this.left = 15
			// 	}
			// })
		})


		// 监听scroll事件获取滚动距离
		// this.handleScroll();

		// setTimeout(() => {
		// 	this.init();
		// }, 5000);



		// 最终效果
		// marked.use({
		// 	mangle: false,
		// 	headerIds: false
		// });
		// this.displayedContent = marked(this.rawContent);
		// this.startTypewriterEffect();
		setTimeout(() => {
			this.elementAddObserver();
		}, 3000);

		
	},
	methods: {
		getRandomThreeUnique(arr) {
			const result = [];
			while (result.length < 3) {
				const randomIndex = Math.floor(Math.random() * arr.length);
				if (!result.includes(arr[randomIndex])) { // 确保不重复添加元素到结果数组中
				result.push(arr[randomIndex]);
				}
			}
			return result;
		},
		// 打字完成的回调用
		typewritingFinish() {

		},
		requestFinish() {
			this.aiIsRequest = false;
		},
		changeShareTitle(text) {
			this.shareTitle = text;
		},
		changeShareSubTitle(text) {
			this.shareSubTitle = text;
		},
		// 修改每条消息对象的内容
		changeMsgArr(subItem, subIndex) {
			let tempMsgArr = JSON.parse(JSON.stringify(this.msgArr))
			tempMsgArr[subIndex]['content'] = subItem.content;
			this.msgArr = tempMsgArr;
		},
		// 点击事件 - AI分析、帮我解读
		clickAiAnalysis(item) {
			if (!this.aiIsRequest) {
				this.aiIsRequest = true;
				if (item) {
					this.msgArr.push({
						"type": 'analysis',
						"text": item
					});
					this.msgArr.push({
						"type": 'aiContent',
						"text": item
					});
					this.$nextTick(() => {
						let element = document.getElementById("contentScrollId-hoverBtn");
						element.scrollTop = element.scrollHeight
					});
				} else {
					this.msgArr.push({
						"type": 'analysis',
						"text": '帮我解读“当日需及时关心的长者”'
					});
					this.msgArr.push({
						"type": 'aiContent',
						"text": '帮我解读“当日需及时关心的长者”'
					});
				}
			} else {
				this.$message.warning('AI正在分析中，请稍侯...');
			}
		},
		clickAiQuestion(item) {
			this.aiIsRequest = true;
			this.msgArr.push({
				"type": 'analysis',
				"text": item
			});
			this.msgArr.push({
				"type": 'aiContent',
				"text": item
			});
			this.$nextTick(() => {
				let element = document.getElementById("contentScrollId-hoverBtn");
				element.scrollTop = element.scrollHeight
			});
		},
		// 网络请求 - AI分析
		requestAiContent() {
			// 消息数组添加消息
			this.msgArr.push({
				"type": 'aiContent'
			});
			return
			this.$get(
				'/api/dean/ai/timelyCareElderAi',
				{
				},
				(res) => {
					if (res.code == 0) {
						// 获取 JSON 数据
						axios({
							method: 'get',
							url: res.data || '',
							headers: {
								'Content-Type': 'application/json',
								'Cache-Control': 'no-cache',
								'Pragma': 'no-cache'
							},
						})
						.then((response) => {
							this.isLoading = false;

							// 消息数组添加消息
							this.msgArr.push({
								"type": 'aiContent',
								"jsonUrl": res.data || '',
								"text": response ? response.content : '',
								// "text": '### 5号 (泛米-1层-1房) 健康信息与护理建议\n\n#### 健康信息\n- **异常情况**：呼吸过速报警\n- **具体数据**：\n  - 10-17：21:13~21:14 发生1次\n  - 10-18：00:32~00:33 发生1次\n  - 10-18：01:11~01:11 发生1次\n  - 10-18：01:33~01:33 发生1次\n  - 10-18：01:36~01:37 发生1次\n  - 10-18：01:54~01:54 发生1次\n  - 10-18：04:05~04:07 发生1次\n  - 10-18：05:24~05:24 发生1次\n  - 10-18：05:30~05:32 发生1次\n  - 10-18：05:38~05:38 发生1次\n  - 10-18：06:18~06:18 发生1次\n  - 10-18：06:26~06:27 发生1次\n  - 10-18：06:33~06:34 发生1次\n  - 10-18：06:37~06:39 发生1次\n  - 10-18：07:10~07:10 发生1次\n  - 10-18：07:12~07:16 发生1次\n  - 10-18：07:39~07:40 发生1次\n  - 10-18：07:42~07:42 发生1次\n  - 10-18：07:44~07:47 发生1次\n  - 10-18：07:50~07:56 发生1次\n  - 10-18：07:58~07:59 发生1次\n  - 10-18：08:24~08:27 发生1次\n  - 10-18：08:30~08:30 发生1次\n  - 10-18：08:42~08:43 发生1次\n  - 10-18：08:46~08:46 发生1次\n  - 10-18：08:48~08:49 发生1次\n  - 10-18：09:02~09:06 发生1次\n  - 10-18：09:26~09:29 发生1次\n  - 10-18：11:43~11:43 发生1次\n\n#### 集中报警时间\n- 01:00~02:00\n- 06:00~08:00\n- 07:00~08:00\n\n#### 科普讲解\n呼吸过速通常与呼吸暂停综合征、慢阻肺、哮喘、心力衰竭、发热等相关，这种情况可能会影响睡眠质量和身体健康（《呼吸系统疾病诊疗手册》）。\n\n#### 异常变化\n- **变化**：无\n- **平时数据**：无\n- **现在数据**：无\n\n#### 建议调高报警阈值\n考虑到5号床位的长者在10月18日发生了29次呼吸过速报警，建议结合实际情况适当调高报警阈值，以减少不必要的频繁报警，同时确保安全（《老年人呼吸系统监测指南》）。\n\n#### 护理建议\n1. **沟通身体情况**：与长者沟通其身体状况，了解是否有不适或病史。\n2. **基础测量**：进行基础的体温、血压、呼吸、心跳测量，记录并观察变化。\n3. **环境调整**：保持室内空气流通，避免过于干燥或潮湿的环境。\n4. **定期检查**：建议定期进行肺功能检查，以早期发现潜在问题。\n5. **心理支持**：提供心理支持，缓解焦虑和压力，有助于改善睡眠质量（《老年人心理护理手册》）。\n\n#### 增值性服务建议\n- **社区医生上门**：建议安排社区医生上门检查，评估长者的健康状况。\n- **医院陪诊**：如有必要，提供医院陪诊服务，确保长者得到及时的医疗照顾。\n\n---\n\n### 3号 (泛米-1层-2房) 健康信息与护理建议\n\n#### 健康信息\n- **异常情况**：体动指数变高\n- **具体数据**：\n  - 09-19：78\n  - 09-20：100\n  - 09-21：40\n  - 09-22：-\n  - 09-23：-\n  - 09-24：-\n  - 09-25：47\n  - 09-26：31\n  - 09-27：100\n  - 09-28：41\n  - 09-29：-\n  - 09-30：-\n  - 10-01：13\n  - 10-02：25\n  - 10-03：55\n  - 10-04：76\n  - 10-05：30\n  - 10-06：44\n  - 10-07：19\n  - 10-08：40\n  - 10-09：48\n  - 10-10：36\n  - 10-11：29\n  - 10-12：47\n  - 10-13：33\n  - 10-14：34\n  - 10-15：41\n  - 10-16：50\n  - 10-17：45\n  - 10-18：95\n\n#### 集中报警时间\n- 无\n\n#### 科普讲解\n体动指数变高是指夜间体动频率升高，是一种睡眠不深、不踏实的表现，这可能是由睡前大量饮酒或者咖啡茶之类的饮品引起的，也可能是身体不适、焦虑或者压力导致的（《睡眠医学》）。\n\n#### 异常变化\n- **变化**：10-18 体动指数变高，达到95\n- **平时数据**：体动指数一般在30-70之间波动\n- **现在数据**：10-18 体动指数为95\n\n#### 建议调高报警阈值\n- 无\n\n#### 护理建议\n1. **沟通身体情况**：与长者沟通其身体状况，了解是否有不适或病史。\n2. **睡前饮食**：避免睡前大量饮用含咖啡因的饮料，如咖啡、茶等。\n3. **心理支持**：提供心理支持，缓解焦虑和压力，有助于改善睡眠质量。\n4. **环境调整**：保持室内安静、舒适，避免噪音干扰。\n5. **定期检查**：建议定期进行身体检查，排除潜在的身体问题（《老年人睡眠管理手册》）。\n\n#### 增值性服务建议\n- **按摩**：提供按摩服务，帮助放松肌肉，改善睡眠质量。\n- **艾灸**：提供艾灸服务，促进血液循环，缓解身体不适。\n- **理疗**：提供理疗服务，针对身体不适进行针对性治疗。\n\n---\n\n### 猜你想问\n1. **呼吸过速的具体原因有哪些？**\n2. **如何有效缓解体动指数变高的问题？**\n3. **老年人睡眠质量差的常见原因和改善方法有哪些？**'
							});
							this.$nextTick(() => {
								marked.use({
									mangle: false,
									headerIds: false
								});
								let markdownStr = response ? response.content : '';
								let needStr = markdownStr || '';
								// 将小波浪号替换为大波浪号,解决删除线的问题
								let newNeedStr = needStr.replace(/~/g, "～")

								this.rawContent = newNeedStr || '';
								this.displayedContent = marked(newNeedStr);
							});
							return
							marked.use({
								mangle: false,
								headerIds: false
							});
							let needStr = markdownStr || '';
							// 将小波浪号替换为大波浪号,解决删除线的问题
							let newNeedStr = needStr.replace(/~/g, "～")

							this.rawContent = newNeedStr || '';
							this.displayedContent = marked(newNeedStr);
						})
						.catch(() => {
							this.isLoading = false;
						});



						marked.use({
							mangle: false,
							headerIds: false
						});
						let needStr = res.data || '';
						// 将小波浪号替换为大波浪号,解决删除线的问题
						let newNeedStr = needStr.replace(/~/g, "～")

						this.rawContent = newNeedStr || '';
						this.displayedContent = marked(newNeedStr);
						this.startTypewriterEffect();
						return
						setTimeout(() => {
							this.elementAddObserver();
						}, 1000);
					} else {
					}
				},
				(err) => {
					this.isLoading = false;
				}
			);
		},
		// 点击了折叠按钮
		clickUnflod() {
			this.isUnfold = !this.isUnfold;
		},
		// 点击AI展示事件
		clickShow() {
			if (!this.dragging) {
				this.itemWidth = 500;
				this.itemHeight = 758;
				this.isShow = true;
			}
			this.optimizedLocation();
		},
		// 关闭AI窗口事件
		clickCloseAi() {
			this.itemWidth = 100;
			this.itemHeight = 100;
			this.isShow = false;
			this.optimizedLocation();
		},
		// 监听鼠标移入窗口滑动区域
		mouseenter() {
			this.isScrollBottom = false;
		},
		// 监听鼠标移出窗口滑动区域
		mouseleave() {
			this.isScrollBottom = true;
		},
		// 对元素添加监听
		elementAddObserver() {
			// 创建tca元素的监听
			const obs1 = new MutationObserver((els)=>{
				let element = document.getElementById("contentScrollId-hoverBtn");
				if (this.isScrollBottom) {
					element.scrollTop = element.scrollHeight
				}
			})
			obs1.observe(document.querySelector(".markdownContent-hoverBtn"),{ 
				attributes: true, 
				childList: true, 
				subtree: true 
			})
		},
		async init() {
            const tokens = marked.lexer(markdown);
            console.log({ tokens });
            // this.mdhtml = marked.parse(tokens);
            let ptokens = [];
            for (let index = 0; index < tokens.length; index++) {
                const tk = tokens[index];
                ptokens = ptokens.concat(parseToken(tk));
            }
            console.log({
                ptokens
            });
            let i = 0;
            let showMdText = "";
            while (i < ptokens.length) {
                const tktxt = ptokens[i];
                showMdText = await renderItemTk(showMdText, tktxt, this);
                i++;	
            }
        },
		startTypewriterEffect() {
			if (this.interval) {
				clearInterval(this.interval);
			}
			this.interval = setInterval(() => {
				if (this.index < this.displayedContent.length) {
					this.index = this.index + 1;
					this.displayedContent = marked.parse(this.rawContent.substring(0, this.index));
				} else {
					clearInterval(this.interval);
				}
			}, 20); // 每100毫秒添加一个字符
		},
		handleScroll() {
			window.addEventListener('scroll', () => {
				// this.scrollTop = window.scrollY;
			})
		},
		// 开始拖拽
		startDrag(event) {
			setTimeout(() => {
				this.dragging = true;
			}, 200);
			this.$refs.floatButton.style.transition = 'none'
			this.mouseX = event.clientX;
			this.mouseY = event.clientY;

			document.addEventListener('mousemove', this.drag);
			document.addEventListener('mouseup', this.stopDrag);
		},
		drag(event) {

			this.left = this.left + (event.clientX - this.mouseX)
			this.top = this.top + (event.clientY - this.mouseY)
			
			this.mouseX = event.clientX;
			this.mouseY = event.clientY;
		},
		// 拖拽结束
		stopDrag() {
			setTimeout(() => {
				this.dragging = false;
			}, 200);

			this.$refs.floatButton.style.transition = 'all 0.3s'
			
			this.optimizedLocation();

			document.removeEventListener('mousemove', this.drag);
			document.removeEventListener('mouseup', this.stopDrag);
		},
		// 校正悬浮窗口
		optimizedLocation() {
			// 垂直
			if (this.isShow) { // AI窗口
				// if (this.top > this.clientHeight - this.itemHeight - this.verticalSpace) {
				// 	this.top = this.clientHeight - this.itemHeight - this.verticalSpace;
				// } else if (this.top < this.verticalSpace) {
				// 	this.top = this.verticalSpace;
				// }
				this.top = this.verticalSpace;
			} else { // 按钮
				if (this.top > this.clientHeight - this.itemHeight - this.verticalSpace) {
					this.top = this.clientHeight - this.itemHeight - this.verticalSpace;
				} else if (this.top < this.verticalSpace) {
					this.top = this.verticalSpace;
				}
			}
			// 水平
			if (this.isShow) { // AI窗口
				// if(this.left > this.clientWidth / 2) {
				// 	this.left = this.clientWidth - this.itemWidth - this.horizontalSpace;
				// } else {
				// 	this.left = this.horizontalSpace;
				// }
				if (this.left < this.horizontalSpace) {
					this.left = this.horizontalSpace;
				} else if (this.left > this.clientWidth - this.itemWidth - this.horizontalSpace) {
					this.left = this.clientWidth - this.itemWidth - this.horizontalSpace;
				}
			} else { // 按钮
				// if(this.left > this.clientWidth / 2) {
				// 	this.left = this.clientWidth - this.itemWidth - this.horizontalSpace;
				// } else {
				// 	this.left = this.horizontalSpace;
				// }
				if (this.left < this.horizontalSpace) {
					this.left = this.horizontalSpace;
				} else if (this.left > this.clientWidth - this.itemWidth - this.horizontalSpace) {
					this.left = this.clientWidth - this.itemWidth - this.horizontalSpace;
				}
			}
		},
		copyTextRemoveMarkdown(markdownString) {
			const html = marked(markdownString); // 使用marked转换Markdown到HTML
			let text = html.replace(/<\/?[^>]+(>|$)/g, ''); // 使用正则表达式去掉HTML标记

			let textarea = document.createElement("textarea");
			textarea.value = text;
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand("copy");
			document.body.removeChild(textarea);
			
			this.toastStr = '复制成功';
			setTimeout(() => {
				this.toastStr = null;
			}, 2000);
		},
		share() {
			this.$post(
				'/api/dean/ai/timelyCareElderShare',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');

						this.editAbnormalTimePopupOutBed = false;
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);



			this.isShowQrCode = !this.isShowQrCode;
			this.$nextTick(function () {
				this.bindQRCode();
			});
		},
		bindQRCode: function () {
			this.qrCodeIsLoading = true;
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDetails, {
					text: 'http://localhost:8080/#/aiShare?jsonUrl=https%3A%2F%2Fql-hospital-test.oss-cn-beijing.aliyuncs.com%2Fpub%2Ffile%2Feeg%2FADT_R20240814153930.json',
					width: 160,
					height: 160,
					colorDark: "#333333", //二维码颜色
					colorLight: "#ffffff", //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.qrCodeIsLoading = false;
			}, 1000);

			// setTimeout(() => {
			// 	//判断二维码的距离实际顶部的距离
			// 	var shareP = document.getElementsByClassName("ant-popover")[0];
			// 	//console.log(shareP)
			// 	this.popoverTop =
			// 		parseInt(shareP.style.top.replace("px", "")) + this.scrollTop;
			// }, 0);
		},

		// 光标进入输入框
		handleFocus() {
			this.isEditing = true;
		},
		// 光标离开输入框
		handleBlur() {
			this.isEditing = false;
		},
		// 回车键点击事件 - 移除焦点
		removeFocus() {
			console.log('回车键点击事件 - 移除焦点')
		},

		adjustHeight() {
			const textarea = this.$refs.deepseekTextareaRef;
			textarea.style.height = 'auto';
			textarea.style.height = Math.min(textarea.scrollHeight, 343) + 'px';
        },
        sendMessage() {
			if (this.aiIsRequest && this.searchText && this.searchText.length > 0) {
				let tempStr = this.searchText.slice();
				this.searchText = null;
				this.$nextTick(() => {
					this.searchText = tempStr;
					this.$refs.deepseekTextareaRef.style.height = 'auto';
				});
				return
			}
			if (this.searchText == '') {
				this.searchText = null;
				this.$nextTick(() => {
					this.searchText = ''
					this.$refs.deepseekTextareaRef.style.height = 'auto';
				});
				return
			}
			if (this.searchText) {
				if (!this.searchText.trim()) return;
			} else {
				this.searchText = null;
				this.$nextTick(() => {
					this.searchText = ''
					this.$refs.deepseekTextareaRef.style.height = 'auto';
				});
				return
			}
			this.clickAiSearch();
			this.searchText = null;
			this.$nextTick(() => {
				this.searchText = ''
				this.$refs.deepseekTextareaRef.style.height = 'auto';
			});
        },
        newLine() {
			this.searchText += '\n';
			this.$nextTick(this.adjustHeight);
        },
        clearInput() {
			this.searchText = '';
			this.$nextTick(() => {
				this.$refs.deepseekTextareaRef.style.height = 'auto';
			});
        },

		// AI搜索
		clickAiSearch() {
			if (!this.aiIsRequest) {
				if (!this.searchText || this.searchText == '') {
					return
				}
			}
			if (this.$refs.aiHoverBtnCard2RefReport && this.$refs.aiHoverBtnCard2RefReport.length > 0) {
				if (this.aiIsRequest) { // 停止请求
					this.$refs.aiHoverBtnCard2RefReport[this.$refs.aiHoverBtnCard2RefReport.length - 1].stopPrint()
					this.aiIsRequest = false;

					return
				}
				if (!this.searchText || this.searchText == '') {
					return
				}
				this.$refs.aiHoverBtnCard2RefReport[this.$refs.aiHoverBtnCard2RefReport.length - 1].aiSearch(this.searchText)
				this.searchText = '';
			} else {
				if (this.$refs.aiHoverBtnCard1RefReport && this.$refs.aiHoverBtnCard1RefReport.length > 0) {
					if (this.aiIsRequest) { // 停止请求
						this.$refs.aiHoverBtnCard1RefReport[this.$refs.aiHoverBtnCard1RefReport.length - 1].stopPrint()
						this.aiIsRequest = false;

						return
					}
					if (!this.searchText || this.searchText == '') {
						return
					}
					this.$refs.aiHoverBtnCard1RefReport[this.$refs.aiHoverBtnCard1RefReport.length - 1].aiSearch(this.searchText)
					this.searchText = '';
				} else {
					this.aiIsRequest = true;
					this.msgArr.push({
						"type": 'analysis',
						"text": this.searchText
					});
					this.msgArr.push({
						"type": 'aiContent',
						"text": this.searchText
					});
					this.$nextTick(() => {
						let element = document.getElementById("contentScrollId-hoverBtn");
						element.scrollTop = element.scrollHeight
					});
				}
			}
		},
	},
};
</script>
<style lang="scss" scoped>

.float-info{
  transition: all 0.3s;
  position: fixed;
  left: 0px;
  top: 0px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  border-radius: 50%;
  img{
    width: 35px;
    height: 35px;
  }
  margin-top: 20px;
}

.copy_share {
	.copy_share_copoyImage {
		background: url("../../assets/icon_home_ai_icon_6.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_shareImage {
		background: url("../../assets/icon_home_ai_icon_8.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
}

.copy_share_copyBtn:hover {
	background: rgba(105, 145, 232, 0.2);
	.copy_share_copoyImage {
		background: url("../../assets/icon_home_ai_icon_7.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_copyText {
		color: rgba(74, 124, 232, 1) !important;
	}
}

.copy_share_shareBtn:hover {
	background: rgba(105, 145, 232, 0.2);
	.copy_share_shareImage {
		background: url("../../assets/icon_home_ai_icon_9.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_shareText {
		color: rgba(74, 124, 232, 1) !important;
	}
}

::v-deep .loadingContent {
	.el-loading-spinner {
		margin-top: -57px !important;
	}
}

.deepseek-textarea {
	flex: 1;
	margin-left: 15px;
	margin-right: 5px;
	min-height: 37px;
	max-height: 343px;
	border: none;
	background: transparent;
	resize: none;
	color: rgba(31, 38, 53, 1);
	font-size: 16px;
	font-family: PingFangSC, PingFang SC;
	line-height: 22px;
	outline: none;
	overflow-y: auto;
	caret-color: rgba(74, 124, 232, 1);
}
.deepseek-textarea::-webkit-scrollbar {
	display: none
}

.deepseek-textarea::placeholder {
	color: rgba(31, 38, 53, 0.2);
}

.search-btn {
	width: 30px;
	height: 30px;
	min-width: 30px;
	min-height: 30px;
	margin-right: 10px;
	background: url('../../assets/icon_ai_search_icon_1.png') no-repeat no-repeat;
	background-size: contain;
	cursor: pointer;
	align-self: flex-end;
	margin-bottom: 1.5px;
}

.search-btn-can-search {
	background: url('../../assets/icon_ai_search_icon_2.png') no-repeat no-repeat;
	background-size: contain;
}

.search-btn-searching {
	background: url('../../assets/icon_ai_search_icon_3.png') no-repeat no-repeat;
	background-size: contain;
}

.hoveBtn {
	.tip {
		display: none;
		position: absolute;
		top: 22px;
		align-items: center;
	}
}

.hoveBtn:hover {
	.tip {
		display: flex;
	}
}

</style>

<style>
.hiddenScrollbar::-webkit-scrollbar {
	display: none
}

.my-el-input-ai-report-container {
	display: flex;
	align-items: center;
	flex: 1;
	margin-left: 16px;
	margin-right: 16px;
	padding-top: 8px;
	padding-bottom: 8px;
	background: rgba(255, 255, 255, 1);
	border-radius: 12px;
	border: 1px solid rgba(74, 124, 232, 0.30);
}

.my-el-input-ai-report-container-editing {
	border: 1px solid rgba(74, 124, 232, 1) !important;
}

</style>